import { Injectable, inject } from '@angular/core';
import Keycloak, { KeycloakProfile } from 'keycloak-js';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private keycloak = inject(Keycloak);

  isLoggedIn(): boolean {
    return !!this.keycloak.authenticated;
  }

  login(): Promise<void> {
    return this.keycloak.login();
  }

  logout(): Promise<void> {
    return this.keycloak.logout({ redirectUri: window.location.origin });
  }

  getToken(): string | undefined {
    return this.keycloak.token;
  }

  getUserProfile(): Promise<KeycloakProfile> {
    return this.keycloak.loadUserProfile();
  }

  async getDisplayName(): Promise<string> {
    const profile = await this.getUserProfile();
    const first = profile.firstName ?? '';
    const last  = profile.lastName ?? '';
    return [first, last].filter(Boolean).join(' ') || profile.username || profile.email || '';
  }

  hasRole(role: string): boolean {
    return this.keycloak.hasRealmRole(role);
  }

  hasAnyRole(...roles: string[]): boolean {
    return roles.some(role => this.keycloak.hasRealmRole(role));
  }

  changePassword(): Promise<void> {
    return this.keycloak.login({ action: 'UPDATE_PASSWORD' });
  }
}
